import { useState } from 'react'
import {
  AppLayout,
  Mtds,
  PlusIcon,
  ScreenHeader,
  ScreenLayout,
  TopBar,
  useGetSampntTypes
} from 'prove-common'
import { AppLogo } from '../components/app-logo/AppLogo'
import { SideBarLayout } from '../components/side-bar-layout/SideBarLayout'
import { SamplingSiteForm } from '../components/reference-data/ReferenceEntityForms'
import { SamplingSitesTable } from '../tables/sampling-sites-table/SamplingSitesTable'
import { ReferenceQueryStatus } from '../components/reference-data/ReferenceQueryStatus'

export const SamplingSitesScreen = () => {
  const [creating, setCreating] = useState(false)
  const { data, isFetching, isError, refetch } = useGetSampntTypes()
  return (
    <AppLayout
      useMobileBar={false}
      isFullWidth
      sidebar={<SideBarLayout />}
      topBar={<TopBar logo={<AppLogo />} title='Uttakssteder' />}
    >
      <ScreenLayout
        header={
          <ScreenHeader
            title='Uttakssteder'
            description='EFSA-kategorier for hvor prøver tas, med norsk og engelsk navn. Dette er ikke geografiske adresser.'
            actions={
              <Mtds.Button
                data-variant='primary'
                onClick={() => setCreating(true)}
              >
                <PlusIcon />
                Legg til uttakssted
              </Mtds.Button>
            }
          />
        }
      >
        <ReferenceQueryStatus
          hasData={data != null}
          isFetching={isFetching}
          isError={isError}
          refetch={refetch}
        />
        {data ? <SamplingSitesTable samplingSites={data} /> : null}
      </ScreenLayout>
      {creating && <SamplingSiteForm onClose={() => setCreating(false)} />}
    </AppLayout>
  )
}
